module.exports = __webpack_public_path__ + "img/delete.849de2ed.png";